import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Nav from "./components/ui/Nav";
import Character from "./pages/Character";
import Gallery from "./pages/Gallery";
import Products from "./pages/Products";
import Top from "./pages/Top";
import World from "./pages/World";
import GA from "./components/utility/GA";
import Footer from "./Footer";
import './styles/app.scss'
import ScrollToTop from "./components/utility/ScrollToTop";
import FieldNotes from "./pages/FieldNotes";
import System from "./pages/System";
import Contest from "./pages/Contest";
import RCC from "./pages/RCC";
import FanArt from "./pages/FanArt";
import Wallpapers from "./pages/Wallpappers";
import CookieConsentAndAnalytics from "./components/utility/CookieConsent";

function App() {
  return ( 
    <div className="App">
      <Router basename={process.env.PUBLIC_URL}>
        <CookieConsentAndAnalytics />
        <ScrollToTop>
          <GA/>
          <Nav/>
          <Routes>
            <Route exact path='/' element={<Top/>}/>
            <Route path='character' element={<Character/>}/>
            <Route path='system' element={<System/>}/>
            <Route path='field-notes' element={<FieldNotes/>}/>
            <Route path='world' element={<World/>}/>
            <Route path='/fanart/pet-department' element={<FanArt/>}/>
            <Route path='/products' element={<Products/>}/>
            <Route path='/gallery' element={<Gallery/>}/>
            <Route path='/gallery/wallpapers' element={<Wallpapers/>}/>
            {/* <Route path='/contest' element={<Contest/>}/>
            <Route path='/contest/reverse-cover' element={<RCC/>}/> */}
          </Routes>
          <div className="portal-container">
            <a href="https://thelegendofheroes.com/" target="_blank" rel="noopener noreferrer">
              <button className="legends">
                The Legend of Heroes - PORTAL SITE
              </button>
            </a>
            <a href="https://thelegendofheroes.com/crossbell/" target="_blank" rel="noopener noreferrer">
                <button className="crossbell">
                  Crossbell - PORTAL SITE
                </button>
            </a>
          </div>
          <Footer/>
        </ScrollToTop>
      </Router>
    </div>
  );
}

export default App;
